module.exports = __webpack_public_path__ + "img/wxicon.1850dfb4.png";